<div class="wrapper" *ngIf="isSpinning">
  <div class="overlay">
    <div class="center" style="background-color: transparent; width: 100%;">
      <mat-progress-spinner
        style="margin:0 auto;"
        [color]="color"
        [mode]="mode"
        [value]="value">
      </mat-progress-spinner>
      <div id="message">
        {{ spinnerMessage }}
      </div>
    </div>
  </div>
</div>
